import { Directive, ElementRef, Input, OnChanges, Renderer2, inject } from "@angular/core";

@Directive({
  selector: `[data-test]`,
  standalone: true
})
export class BdDataTestDirective implements OnChanges {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);


  @Input('data-test') testId: string;

  ngOnChanges(): void {
    while (this.testId.includes(' ')) {
      this.testId = this.testId.replace(' ', '_');
    }
    this.renderer.setAttribute(this.el.nativeElement, "data-test", this.testId)
  }
}
